import { render } from "./GgmSendToken.vue?vue&type=template&id=150e3be6&ts=true"
import script from "./GgmSendToken.vue?vue&type=script&lang=ts"
export * from "./GgmSendToken.vue?vue&type=script&lang=ts"

import "./GgmSendToken.vue?vue&type=style&index=0&id=150e3be6&lang=less"

import exportComponent from "D:\\官网改\\mogahome\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__